var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "display-alert", class: _vm.type }, [
    _vm.type === "error" || _vm.type === "warning"
      ? _c("div", [_c("img", { attrs: { src: _vm.imagePath } })])
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c("span", { domProps: { innerHTML: _vm._s(_vm.$t(_vm.text)) } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }